import apiClient from '@shared/apiClient'

const SERVICE_PATH = 'search'

export const getApiClient = () => apiClient.partneringOnePlus(SERVICE_PATH)
